// extracted by mini-css-extract-plugin
export default {"chatInputWrapper":"InputChat_chatInputWrapper__bTr3K"};